import { useLocation } from '@tanstack/react-router';

/**
 * Hook to determine if the current route is an authentication-related page
 * @returns true if on login, logout, auth callback, or tenant limit exceeded pages
 */
export function useIsAuthRoute(): boolean {
  const location = useLocation();
  const authRoutes = [
    '/login',
    '/logout',
    '/auth/callback',
    '/auth/tenant-limit-exceeded',
  ];

  return authRoutes.some(route => location.pathname.startsWith(route));
}
